const landingPageUrl = process.env.REACT_APP_LANDING_PAGE_URL;

export const NAV_LOCATION = {
  SIDEBAR: "sidebar",
  MENU: "menu"
};

const ALL_ROLES = ["guest", "private", "admin"];
const SIGNED_IN = ["private", "admin"];

/**
 * full list of nav items for both sidebar and menu
 */
export const NAV_ITEMS = [
  {
    key: "browse",
    title: "Browse",
    path: "/",
    locations: [NAV_LOCATION.SIDEBAR, NAV_LOCATION.MENU],
    roles: ALL_ROLES
  },
  {
    key: "projects",
    title: "Projects",
    path: "/project",
    locations: [NAV_LOCATION.SIDEBAR, NAV_LOCATION.MENU],
    roles: SIGNED_IN
  },
  {
    key: "playlists",
    title: "Playlists",
    path: "/playlists",
    locations: [NAV_LOCATION.SIDEBAR, NAV_LOCATION.MENU],
    roles: ALL_ROLES
  },
  {
    key: "favorites",
    title: "Favorites",
    path: "/favorites",
    locations: [NAV_LOCATION.SIDEBAR, NAV_LOCATION.MENU],
    roles: SIGNED_IN
  },
  {
    key: "orders",
    title: "My Orders",
    path: "/orders",
    locations: [NAV_LOCATION.SIDEBAR, NAV_LOCATION.MENU],
    roles: SIGNED_IN
  },
  {
    key: "settings",
    title: "Settings",
    path: "/settings",
    locations: [NAV_LOCATION.SIDEBAR, NAV_LOCATION.MENU],
    roles: SIGNED_IN,
    nestedLinks: [
      {
        key: "settings-general",
        title: "General",
        path: "/settings/general"
      },
      { key: "settings-team", title: "My team", path: "/settings/my-team" }
    ]
  },
  {
    key: "login",
    title: "Log in",
    path: "/signin",
    locations: [NAV_LOCATION.MENU],
    roles: ["guest"]
  },
  {
    key: "logout",
    title: "Log out",
    path: "/logout",
    locations: [NAV_LOCATION.MENU],
    roles: SIGNED_IN
  },
  {
    key: "divider",
    locations: [NAV_LOCATION.MENU],
    roles: ALL_ROLES
  },
  {
    key: "home",
    title: "Home",
    path: landingPageUrl,
    locations: [NAV_LOCATION.MENU],
    roles: ALL_ROLES,
    external: true
  },
  {
    key: "licensing",
    title: "Licensing",
    path: "/licensing",
    locations: [NAV_LOCATION.MENU],
    roles: ALL_ROLES
  },
  {
    key: "contact",
    title: "Contact",
    path: "/contact",
    locations: [NAV_LOCATION.MENU],
    roles: ALL_ROLES
  },
  {
    key: "ingest",
    title: "Ingest Tracks",
    path: "/admin/upload",
    locations: [NAV_LOCATION.MENU],
    roles: ["admin"]
  },
  {
    key: "reindex",
    title: "Reindex Search",
    path: "/admin/reindex",
    locations: [NAV_LOCATION.MENU],
    roles: ["admin"]
  }
];
